const colors = {
  text: "#222222",
  border: "#eee",
  purple: `rgb(150, 60, 255)`,
  darkPurple: `rgb(55, 0, 60)`,
  green: "green",
  grey: "#bbb"
}
export default colors
